import LinkInBioPage from "@/components/LinkInBioPage";
import ctaBackground from "@/assets/cta-background.png";
import { useEvents } from "@/hooks/useEvents";
import { trackInitiateCheckout, trackVendorApplyClick, DEFAULT_TICKET_PRICE } from "@/lib/analytics";

const Tickets = () => {
  const { data: events } = useEvents();
  // Pick the soonest upcoming event with a ticket URL
  const today = new Date().toISOString().slice(0, 10);
  const activeEvent = events
    ?.filter((e) => e.date >= today && e.ticket_url)
    .sort((a, b) => a.date.localeCompare(b.date))[0];

  const ticketHref = activeEvent?.ticket_url || "/events";
  const price = activeEvent?.ticket_price ?? DEFAULT_TICKET_PRICE;

  return (
    <LinkInBioPage
      headline="June 20 — Dallas Market Hall"
      subtext="DFW's largest sneaker marketplace."
      primaryCta={{
        label: "Get Tickets — June 20",
        href: ticketHref,
        caption: `Wristbands from $${price.toFixed(0)}`,
        onClick: () => {
          if (activeEvent?.ticket_url) {
            trackInitiateCheckout({
              eventName: activeEvent.title,
              eventId: activeEvent.id,
              ticketUrl: activeEvent.ticket_url,
              price: activeEvent.ticket_price,
            });
          }
        },
      }}
      secondaryCta={{
        label: "Apply as a Vendor — June 20",
        href: "/apply",
        onClick: () => trackVendorApplyClick("tickets_link_in_bio"),
      }}
      sectionLabel="Explore"
      backgroundImage={ctaBackground}
    />
  );
};

export default Tickets;
